import * as React from "react";

import "./table.scss";

import {isApiTrue} from "@Common/logic/is-api-true";
import {cs}        from "@Common/react/chain-services";
import {sum}       from "@Common/utils/collections";

import {Checkbox}    from "../../../../../../../../common/design2/checkbox/checkbox";
import {DataTableD1} from "../../../../../../../../common/design2/data-table/data-table-d1";
import {getStreet}   from "../../common/get-street";

export const Table = (
    {
        masterCheckbox, filteredRecords, getFooter, count, renderActions, getExcludedCounts, setStreetSelected
    }
) => cs(
    () => DataTableD1({
        className: "table-4ip",
        pageSize: 10,
        columns: Columns({
            count,
            masterCheckbox,
        }),
        darkRows: "even",
        rows: filteredRecords.map((r) => {
            const street = getStreet(r);
            const checked = isApiTrue(street.display_address);
            return {
                key: street.address,
                columns: [
                    {
                        render: () => Checkbox({
                            checked,
                            onClick: () => setStreetSelected(street, !checked),
                            xdQaName: "Build Radius List "+street.address.split("^_^")[0],
                        }),
                    },
                    {
                        render: () => <>
                            <div className="text" xd-qa-type="label" xd-qa-name={"Build Radius List "+street.address.split("^_^")[0]}>
                                {street.address.split("^_^")[0]}
                            </div>
                            <div className="count" xd-qa-type="label" xd-qa-name={"Build Radius List "+street.address.split("^_^")[0]+" Count"}>
                                ({+street.count - sum(Object["values"](getExcludedCounts(street)))})
                            </div>
                            {getExcludedCounts(street).dnm > 0 && <div className="text danger" xd-qa-type="label" xd-qa-name={street.address.split("^_^")[0]}>
                                <span xd-qa-type="text" xd-qa-name="Do Not Mail">{`(Excluding ${getExcludedCounts(street).dnm} Do Not Mail)`}</span>
                            </div>}
                        </>,
                        sortValue: () => street.address,
                    },
                    {
                        render: () => street.min,
                        domAttrs: {
                            "xd-qa-type": "label",
                            "xd-qa-name": "Build Radius List "+street.address.split("^_^")[0]+" Start House",
                        },
                    },
                    {
                        render: () => street.max,
                        domAttrs: {
                            "xd-qa-type": "label",
                            "xd-qa-name": "Build Radius List "+street.address.split("^_^")[0]+" End House",
                        },
                    },
                    {
                        render: () => street.zip_code,
                        sortValue: () => street.zip_code,
                        domAttrs: {
                            "xd-qa-type": "label",
                            "xd-qa-name": "Build Radius List "+street.address.split("^_^")[0]+" Zip Code",
                        },
                    },
                    {
                        render: () => <>
                            {renderActions(street)}

                        </>,
                    },
                ],
            };
        }),
        emptyAction: {
            label: "No street(s) found",
        },
        getFooter: ({colCount, pagination}) => ({
            columns: [
                {
                    colSpan: colCount,
                    render: () => getFooter({pagination})
                },
            ],
        }),
    }),
);

const Columns = ({masterCheckbox, count}) => [
    {
        width: "1%",
        className: "checkbox",
        render: () => Checkbox({
            ...masterCheckbox,
            xdQaName: "Build Radius List Street Master Checkbox"
        }),
    },
    {
        width: "20%",
        label: "STREET",

        subTitle: `(${count.selected} of ${count.total} streets selected)`,

        className: "address",
        sortable: {
            defaultDirection: "asc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Build Radius List Street",
        },
    },
    {
        width: "1%",
        label: "START HOUSE",
        className: "start-house",
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Build Radius List Start House",
        },
    },
    {
        width: "1%",
        label: "END HOUSE",
        className: "end-house",
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Build Radius List End House",
        },
    },
    {
        width: "1%",
        label: "ZIP CODE",
        className: "zip",
        sortable: {
            defaultDirection: "asc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Build Radius List Street Zip Code",
        },
    },
    {
        width: "1%",
        label: "ACTION",
        className: "actions",
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Build Radius List Action",
        },
    },
];